<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    大剧院站<br>
站点介绍<br>
大剧院站位于解放路与深南东路交叉口处。在站址周围有地王大厦、蔡屋围酒店、中国人民银行、中国农业银行、平安银行大厦、书城等大中型建筑，是深圳市的金融中心区。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:18	00:03	1号线	2分钟	4分40秒<br>
机场东	06:26	23:06	1号线	2分钟	4分40秒<br>
赤湾	06:02	23:42	2号线	2分35秒	5分45秒<br>
莲塘	06:19	23:57	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:18	00:01	1号线	3分45秒	5分45秒<br>
机场东	06:26	23:06	1号线	3分45秒	5分45秒<br>
赤湾	06:07	23:42	2号线	4分钟	5分钟<br>
莲塘	06:19	23:57	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:18	01:01	1号线	3分45秒	5分45秒<br>
机场东	06:26	00:06	1号线	3分45秒	5分45秒<br>
赤湾	06:07	00:32	2号线	4分钟	5分钟<br>
莲塘	06:19	00:57	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
B出入口:<br>
新闻大厦、邓小平画像、深圳荔枝公园、深圳市青少年活动中心、大剧院、中国农业银行深圳市分行、京基百纳•空间（KK MALL）<br><br>
C出入口:<br>
深南东路北侧<br><br>
D出入口:<br>
解放路南侧、宝安南路、桂园路、红桂路、深圳市公安局、深圳市防雷中心、地王大厦、深圳开放大学、深圳大学继续教育学院、深圳市中医院门诊部<br><br>
E出入口:<br>
深南东路南侧（西）、金塘街、深圳平乐骨伤科医院、御河堤<br><br>
F出入口:<br>
深南东路南侧（东）、深圳书城、罗湖高级中学、深圳证券交易所、都市名园、幸福里、嘉宾花园<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 市公安局①<br>
3、10、12、101、203、215、223、N3、M190<br><br>
B出入口:<br>
公交站名： 市公安局②<br>
204、M106、M481、N4<br><br>
C出入口:<br>
公交站名： 地王大厦<br>
29、214、M112、M559、M482<br><br>
E出入口:<br>
公交站名： 地王大厦<br>
3、10、12、14、101、223、M152、M191、203、N3、M190、M192<br><br>
E出入口:<br>
公交站名： 深圳书城<br>
104、204、215、E8、M103、M106、M481、85、113、M133、29、M112、M559、大鹏假日专线4<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>







